import { Box, IconButton } from "@mui/material"
import { CommentIcon, HeartIcon, SaveIcon } from "../../../../../../../core/global/Icons"
import { MoreHoriz } from "@mui/icons-material"

export const ActionButton = ({ showBottomNav, itemData, actionHandler, setShowComment}) => {
    const formatNumber = (num) => {
        if (num >= 1_000_000) {
            return (num / 1_000_000).toFixed(num % 1_000_000 === 0 ? 0 : 1) + 'M';
        } else if (num >= 1_000) {
            return (num / 1_000).toFixed(num % 1_000 === 0 ? 0 : 1) + 'k';
        } else {
            return num?.toString() || '0';
        }
    };

    const reaction_count = formatNumber(itemData.reaction)
    const comment_count = formatNumber(itemData.comment)
    const save_count = formatNumber(itemData.save)

    const handleNativeShare = async () => {
        if (navigator.share) {
            try {
                await navigator.share({
                    title: 'Check this out!',
                    text: 'Check this from philtaxes',
                    url: window.location.href,
                });
            console.log('Successfully shared!');
            } catch (error) {
            console.error('Error sharing:', error);
            }
        } else {
            alert('Web Share API is not supported in your browser.');
        }
    };

	return (
		<Box
            width="100%"
            p="16px 24px"
            display="flex"
            justifyContent="space-between"
            alignItems="center"
            bgcolor="rgba(255, 255, 255, 0.9)"
            boxShadow="0px 0px 4px 0px rgba(0, 0, 0, 0.12)"
            position="fixed"
            bottom="0px"
            borderRadius="8px"
            zIndex={1}
            sx={{
                transition: 'transform 0.5s ease, opacity 0.5s ease',
                transform: showBottomNav ? 'translateY(0)' : 'translateY(100%)',
                opacity: showBottomNav ? 1 : 0,
                pointerEvents: showBottomNav ? 'auto' : 'none', // prevent clicks when hidden
            }}
        >
            
            <Box height="100%" width="100%" display="flex" alignItems="center" gap="16px">
                <Box display="flex" alignItems="center" gap="6px">
                    <IconButton sx={{padding: '4px'}} onClick={actionHandler} >
                        <HeartIcon height="25px" width="24px" type="default"/>
                    </IconButton>
                    <Box fontSize="14px" color="#8F969D">{reaction_count}</Box>
                </Box>
                <Box display="flex" alignItems="center" gap="6px">
                    <IconButton onClick={() => setShowComment(true)} sx={{padding: '4px'}} >
                        <CommentIcon height="25px" width="24px" fill="none" stroke="#292C2F"/>
                    </IconButton>
                    <Box fontSize="14px" color="#8F969D">{comment_count}</Box>
                </Box>
                <Box display="flex" alignItems="center" gap="4px">
                    <IconButton sx={{padding: '4px'}} onClick={actionHandler} >
                        <SaveIcon height="25px" width="24px" type="default"/>
                    </IconButton>
                    <Box fontSize="14px" color="#8F969D">{save_count}</Box>
                </Box>
            </Box>
            <IconButton onClick={handleNativeShare}>
                <MoreHoriz/>
            </IconButton>
        </Box>
	)
}
